import { Box } from "@mui/material";

const TabPanel = ({ children, value, index, style, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`tabpanel-${index}`}
    aria-labelledby={`tab-${index}`}
    tabIndex={0}
    style={{ flex: 1, minWidth: 0, overflow: "hidden", ...style }}
    {...other}
  >
    {value === index && (
      <Box sx={{ p: 1, width: "100%", height: "100%" }}>{children}</Box>
    )}
  </div>
);

export default TabPanel;
